export default __webpack_public_path__ + "static/media/circulo-aprobado.63cfb2dc.svg";